import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { SKIP_AUTH } from '../../../../core/tokens/http-context-tokens';

@Injectable({
  providedIn: 'root',
})
export class ContactValidationApiService {
  private readonly url = `${environment.APP_CORE_DATA_SERVICE_BASE_URL}/api/v1/contacts`;
  private readonly skipAuthContext = new HttpContext().set(SKIP_AUTH, true);

  constructor(private readonly http: HttpClient) {}

  validateMailAddress(id: string): Observable<string> {
    return this.http.put(`${this.url}/mail/validate/${id}`, null, {
      responseType: 'text',
      context: this.skipAuthContext,
    });
  }

  revokeMailAddress(id: string): Observable<string> {
    return this.http.put(`${this.url}/mail/revoke/${id}`, null, {
      responseType: 'text',
      context: this.skipAuthContext,
    });
  }
}
